import React from 'react';
import { RentalsReservationInstance } from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

const AgentBookingCard: React.FC<{ reservation?: RentalsReservationInstance }> = ({ reservation }) => (
    <>
        <Typography color="textSecondary" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
            <HelpOutlineIcon color="primary" sx={{ fontSize: 40, margin: '0 12px 0 0' }} />
            <span>
                Need help or to change your booking, please contact <strong>{reservation?.agentName || 'agent'}</strong>
            </span>
        </Typography>
        <Divider
            sx={(theme) => ({
                height: '10px',
                backgroundColor: theme.palette.primary.main,
                margin: '30px 0',
                width: '100%',
                border: 'none',
            })}
        />
    </>
);

export default AgentBookingCard;
